module.exports = __webpack_public_path__ + "static/media/solution18.c1aff0c8.jpeg";